<template>

  <div>
    <!--    &lt;!&ndash; Version Toggle &ndash;&gt;-->
    <!--    <div class="version-switcher mb-2">-->
    <!--      <b-button-->
    <!--        v-b-tooltip.hover-->
    <!--        :variant="useV2 ? 'primary' : 'outline-primary'"-->
    <!--        size="sm"-->
    <!--        class="version-switch-btn"-->
    <!--        :title="useV2 ? $t('Switch to old version') : $t('Switch to new version')"-->
    <!--        pill-->
    <!--        @click="toggleVersion(!useV2)"-->
    <!--      >-->
    <!--        <feather-icon-->
    <!--          :icon="useV2 ? 'ZapIcon' : 'ClockIcon'"-->
    <!--          size="16"-->
    <!--          class="mr-50 version-icon"-->
    <!--        />-->
    <!--        <span>{{ useV2 ? $t('New Version') : $t('Old Version') }}</span>-->
    <!--      </b-button>-->
    <!--    </div>-->

    <!-- Filters -->
    <filters
      :customer-filter.sync="customerFilter"
      :status-filter.sync="statusFilter"
    />

    <!-- Table Container Card -->
    <model-list-table
      ref="modelListTable"
      :store-module-name="storeModuleName"
      :table-columns="tableColumns"
      :filters-list="filtersList"
      :query-params="getQueryParams"
      :add-action="false"
      :view-action="true"
      :view-action-route="viewActionRoute"
      :edit-action="false"
      :delete-action="true"
      :extra-actions="[]"
      :is-sortable="false"
    >
      <!-- Column: Order Number -->
      <template #cell(order_number)="data">
        <b-link
          :to="{ name: useV2 ? 'ordersV2.view' : 'orders.view', params: { id: data.item.id } }"
          class="font-weight-bold d-block text-nowrap"
        >
          {{ data.item.order_number }}
        </b-link>
      </template>
      <!-- Column: Preparation Date -->
      <template #cell(preparation_started_at)="data">
        <div v-if="data.item.preparation_started_at">
          <span class="text-nowrap">{{ formatDate(data.item.preparation_started_at) }}</span>
          <br>
          <span class="text-nowrap">{{ formatTime(data.item.preparation_started_at) }}</span>
        </div>
        <span v-else>-</span>
      </template>
      <!-- Custom cell: Order Status -->
      <template #cell(editable_order_status)="data">
        <b-dropdown
          v-if="data.item.allowed_status_options && data.item.allowed_status_options.length"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          :text="$t(`modules.orders.status.${data.item.status || data.item.order_status}`)"
          :variant="resolveOrderStatusVariant(data.item.status || data.item.order_status)"
          :disabled="statusUpdateInProgress[data.item.id]"
          size="sm"
        >
          <b-dropdown-item
            v-for="status in data.item.allowed_status_options"
            :key="`dropdown-status-${data.item.id}-${status}`"
            @click="onClickUpdateOrderStatus(data.item, status)"
          >
            {{ $t(`modules.orders.status.${status}`) }}
          </b-dropdown-item>
        </b-dropdown>
        <b-badge
          v-else-if="data.item.order_status"
          v-t="`modules.orders.status.${data.item.order_status}`"
          pill
          :variant="`light-${resolveOrderStatusVariant(data.item.order_status)}`"
          class="text-capitalize"
        >
          {{ data.item.status }}
        </b-badge>
        <b-badge
          v-else-if="data.item.status"
          v-t="`modules.orders.status.${data.item.status}`"
          pill
          :variant="`light-${resolveOrderStatusVariant(data.item.status)}`"
          class="text-capitalize"
        >
          {{ data.item.status_description || data.item.status }}
        </b-badge>
      </template>
      <!-- Override Add Button Route: TODO: Remove once we end the v1 of orders -->
      <template #pre_bulk_actions>
        <b-button
          variant="primary"
          class="mr-1"
          :to="{ name: addActionRoute }"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-50"
          />
          <span
            v-t="{path:'actions.add', args: {'model': $t(`modules.${storeModuleName}.s_s`)}}"
            class="align-middle text-nowrap"
          />
        </b-button>
      </template>
    </model-list-table>

    <!-- modal create waybill -->
    <wizard-modal-create-waybill
      v-if="selectedOrder"
      :order-data="selectedOrder"
      :item-id="selectedOrder.id"
      :currency-code="selectedOrder.currency_code"
      :is-visible="isWaybillModalVisible"
      @update:is-visible="v => isWaybillModalVisible = v"
      @hidden="isWaybillModalVisible = false"
      @submitted="onOrderUpdated"
    />

    <!-- modal add shipment -->
    <modal-add-shipment
      v-if="selectedOrder"
      :order-data="selectedOrder"
      :is-visible="isShipmentModalVisible"
      @update:is-visible="v => isShipmentModalVisible = v"
      @hidden="isShipmentModalVisible = false"
      @submitted="onOrderUpdated"
    />
  </div>
</template>

<script>
import store from '@/store'
import {
  ref, computed, onUnmounted, watch,
} from 'vue'
import {
  BBadge, BDropdown, BDropdownItem, BButton, VBTooltip, BLink,
} from 'bootstrap-vue'
import {formatDate, formatDatetime, formatTime} from '@core/utils/filter'
import ModelListTable from '@/views/models/common/ModelListTable.vue'
import Ripple from 'vue-ripple-directive'
import {
  canUseFeature, handleBadRequestError, toast, useRouter,
} from '@core/utils/utils'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import WizardModalCreateWaybill from '@/views/models/waybills/add/WizardModalCreateWaybill.vue'
import ModalAddShipment from '@/views/models/orders/add/ModalAddShipment.vue'
import { resolveOrderStatusVariant } from '@core/utils/constants'
import orderStoreModule from '../orderStoreModule'
import Filters from './Filters.vue'

export default {
  components: {
    BLink,
    Filters,
    ModelListTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BButton,
    WizardModalCreateWaybill,
    ModalAddShipment,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },

  methods: {
    formatDate,
    formatTime,
  },
  setup() {
    const { t } = useI18nUtils()
    const { route, router } = useRouter()
    const STORE_MODULE_NAME = 'orders'

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, orderStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    // Initialize filters from URL query params
    const customerFilter = ref(route.value.query.customer_id || null)
    const statusFilter = ref(route.value.query.status || null)
    const modelListTable = ref(null)
    const statusUpdateInProgress = ref({})
    const selectedOrder = ref(null)
    const isWaybillModalVisible = ref(false)
    const isShipmentModalVisible = ref(false)

    // Version toggle - load from localStorage, default to v2
    const ORDER_VERSION_KEY = 'order_page_version'
    // const useV2 = ref(localStorage.getItem(ORDER_VERSION_KEY) !== 'v1')
    const useV2 = ref(true)

    const toggleVersion = v2 => {
      useV2.value = v2
      localStorage.setItem(ORDER_VERSION_KEY, v2 ? 'v2' : 'v1')
      // Refresh the table to update routes
      if (modelListTable.value && modelListTable.value.refreshData) {
        modelListTable.value.refreshData()
      }
    }

    // Computed routes based on version
    const viewActionRoute = computed(() => (useV2.value ? 'ordersV2.view' : 'orders.view'))
    const addActionRoute = computed(() => (useV2.value ? 'ordersV2.add' : 'orders.add'))

    // Watch filters and sync to URL query params
    watch([customerFilter, statusFilter], () => {
      const query = {}

      // Only add non-null/non-empty filter values to query
      if (customerFilter.value) {
        query.customer_id = customerFilter.value
      }
      if (statusFilter.value) {
        query.status = statusFilter.value
      }

      // Update URL without adding to history
      router.replace({ query }).catch(() => {})
    })

    const tableColumns = [
      {
        key: 'checkbox',
        label: '',
        sortable: false,
      },
      { key: 'order_number', sortable: false, label: 'ID' },
      {
        key: 'related_customer', sortable: true, label: 'modules.customers.s_c',
      },
      {
        key: 'order_total', sortable: true, label: 'Order Total',
      },
      { key: 'editable_order_status', sortable: true, label: 'Status' },
      {
        key: 'paid_at',
        label: 'Payment Date',
        formatter: formatDatetime,
        sortable: true,
      },
      {
        key: 'created_at',
        label: 'Creation Date',
        formatter: formatDatetime,
        sortable: true,
      },
      {
        key: 'updated_at',
        label: 'Last Update',
        formatter: formatDatetime,
        sortable: true,
      },
      { key: 'actions' },
    ]

    // Add a column to table columns based on feature flag
    if (canUseFeature('order_items_preparation_progress')) {
      tableColumns.splice(-2, 1, {
        key: 'preparation_started_at', sortable: true, label: 'Preparation Start',
      })
    }

    const filtersList = [customerFilter, statusFilter]
    const getQueryParams = () => ({
      customer_id: customerFilter.value,
      status: statusFilter.value,
    })

    // Update order status
    const updateOrderStatus = (order, status) => {
      statusUpdateInProgress.value[order.id] = true
      store.dispatch(`${STORE_MODULE_NAME}/updateOrderStatus`, { orderId: order.id, status })
        .then(response => {
          toast('success', t('message.operation_success'))
          // Refresh the table
          if (modelListTable.value && modelListTable.value.refreshData) {
            modelListTable.value.refreshData()
          }
        })
        .catch(e => {
          if (!handleBadRequestError(e, t)) {
            throw e
          }
        })
        .finally(() => {
          statusUpdateInProgress.value[order.id] = false
        })
    }

    // Handle status update click with modal checks
    const onClickUpdateOrderStatus = (order, status) => {
      // Fetch full order data if needed for modals
      const fetchFullOrderData = () => store.dispatch(`${STORE_MODULE_NAME}/fetchOne`, order.id)
        .then(response => {
          selectedOrder.value = response
          return response
        })

      // Check if status requires waybill
      if (order.status_options_requires_waybill && order.status_options_requires_waybill.includes(status)) {
        fetchFullOrderData().then(fullOrder => {
          if (!fullOrder.items || !fullOrder.items.length) {
            toast('danger', t('modules.waybills._create._messages.no_unshipped_items'))
            return
          }
          isWaybillModalVisible.value = true
        })
        return
      }

      // Check if status requires shipment
      if (order.status_options_requires_shipment && order.status_options_requires_shipment.includes(status)) {
        fetchFullOrderData().then(() => {
          isShipmentModalVisible.value = true
        })
        return
      }

      // Otherwise, just update the status
      updateOrderStatus(order, status)
    }

    // Refresh table after modal submission
    const onOrderUpdated = () => {
      if (modelListTable.value && modelListTable.value.refreshData) {
        modelListTable.value.refreshData()
      }
      selectedOrder.value = null
    }

    return {
      // Extra Filters
      customerFilter,
      statusFilter,

      // Table props
      tableColumns,
      storeModuleName: STORE_MODULE_NAME,
      filtersList,
      getQueryParams,
      viewActionRoute,
      addActionRoute,

      // Version toggle
      useV2,
      toggleVersion,

      // Refs
      modelListTable,
      statusUpdateInProgress,
      selectedOrder,
      isWaybillModalVisible,
      isShipmentModalVisible,

      // Methods
      onClickUpdateOrderStatus,
      onOrderUpdated,

      // Utilities
      resolveOrderStatusVariant,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.version-switcher {
  display: flex;
  justify-content: flex-end;
}

.version-switch-btn {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 1rem;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss">

$gray-300: #dee2e6 !default;
$border-color: $gray-300 !default;

::v-deep .b-table {
  tbody {
    tr {
      //cursor: move;
    }
  }
}

.b-table {
  tbody {
    tr.ready-for-drag {
      transform: translateY(-4px);
      box-shadow: 0 3px 10px 0 $border-color;
      transition: all 0.2s;
    }
    tr {
      &:has(td .draggable-handle) {
        transform: translateY(-4px);
        box-shadow: 0 3px 10px 0 $border-color;
        transition: all 0.2s;
      }
    }
  }
}

.btn-link:hover {
  color: #5d6064 !important;
}
</style>
